import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SxSPdf" */ './lazyIndex'));

// Delayed Loaded Components
export const PdfJsPreview = createLazyComponent(lazyModule, m => m.PdfJsPreview);

// This will generate the worker script in owa.vendors~SxSPdfWorker.js
// And it will be used in PdfJsPreview.tsx
new LazyModule(() =>
    import(/* webpackChunkName: "SxSPdfWorker" */ 'pdfjs-dist/build/pdf.worker.min')
);
export { PdfJsPreviewPrintable, PdfJsPreviewProps } from './components/PdfJsPreview';
export { ComponentClass } from 'react';
